export default __webpack_public_path__ + "static/media/skippedmeal@3x.b3c46fe6.jpg";